import { Pipe, PipeTransform } from '@angular/core';
import { isNilOrEmpty } from 'helpers';
import { isNil } from 'lodash-es';
/*
 * Returns friendly address string
*/
@Pipe({ name: 'cityState' })
export class CityStatePipe implements PipeTransform {
  transform(value: any): string {
    if (isNil(value)) {
      return '';
    }

    const address = value as { city: string; state: string };
    const cityState = [address.city, address.state].filter(v => !isNilOrEmpty(v));

    if (cityState.length === 2) {
      return cityState.join(', ');
    }

    return cityState.join('');
  }
}
